import translate from './translate'

const Translate = props => {
  const { children } = props

  if (typeof children !== 'string') {
    return ''
  }

  return translate(children)
}

export default Translate
